module.exports = __webpack_public_path__ + "static/media/close.f20cc07b.svg";